<main class="main">
  <div class="main-content">

    @switch (state()) {
      @case (State.HOME) {
        <app-home (onStart)="startQuiz()"></app-home>
      }
      @case (State.QUIZ) {
        <div class="quiz-container fadein animation-duration-500">

          <p-carousel
            [value]="questions()"
            [numVisible]="1"
            [numScroll]="1"
            [showIndicators]="false"
            [showNavigators]="false"
            [page]="currentIndex()">

            <ng-template let-q pTemplate="item">
              <div disableSwipe style="width: 100%; height: 100%;">
                <app-slide [question]="q" (onSelect)="next($event)" (prev)="prev()"></app-slide>
              </div>
            </ng-template>

          </p-carousel>
        </div>
      }
      @case (State.FORM) {
        <app-form [result]="result()" (afterSubmit)="seeResult()"></app-form>
      }
      @case (State.RESULT) {
        <app-result [result]="result()" (home)="home()"></app-result>
      }
    }
  </div>
</main>
